import React from 'react';
import { ProgramRejoin } from '../../../components/ProgramRejoin';
import { ProgramUnavailable } from '../../../../../ChallengesPage/Widget/components/ProgramUnavailable';
import { StepViewBreadcrumbs } from '../../../components/StepViewBreadcrumbs';
import { Props } from '../interfaces';

export interface ContentPlaceholdersProps {
  props: Props;
  type: 'SidebarGeneral' | 'SidebarOverview';
  withMobileBreadcrumbs: boolean;
  goToMobileList: () => void;
}

export const ContentPlaceholders: React.FC<ContentPlaceholdersProps> = ({
  props,
  type,
  withMobileBreadcrumbs,
  goToMobileList,
}) => {
  const { isParticipantInSuspendedState, isParticipantInLockedState } = props;

  return (
    <>
      {isParticipantInSuspendedState ? (
        <ProgramRejoin
          type={type}
          prefix={
            props.isMobile && withMobileBreadcrumbs ? (
              <StepViewBreadcrumbs goToMobileList={goToMobileList} />
            ) : null
          }
        />
      ) : null}
      {isParticipantInLockedState ? (
        <ProgramUnavailable
          type={type}
          prefix={
            props.isMobile && withMobileBreadcrumbs ? (
              <StepViewBreadcrumbs goToMobileList={goToMobileList} />
            ) : null
          }
        />
      ) : null}
    </>
  );
};
